import { render, staticRenderFns } from "./BracketProgress.vue?vue&type=template&id=a896cf0e&scoped=true"
import script from "./BracketProgress.vue?vue&type=script&lang=js"
export * from "./BracketProgress.vue?vue&type=script&lang=js"
import style0 from "./BracketProgress.vue?vue&type=style&index=0&id=a896cf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a896cf0e",
  null
  
)

export default component.exports